import { createFileRoute } from "@tanstack/react-router";
import AdminAiPage from "@/admin/pages/ai";

export const Route = createFileRoute("/admin/ai")({
  component: AdminAiPage,
});
